import React from 'react';
import { Tag } from 'antd';

/** On a section that ignores the platform / version filter while one is set. */
export const WholeGameTag: React.FC<{ show?: boolean }> = ({ show }) =>
  show ? (
    <Tag style={{ marginLeft: 8, fontWeight: 'normal' }} data-whole-game>
      All platforms and versions
    </Tag>
  ) : null;
